import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FileManagerModule } from '@sendpulse/file-manager';
import { SortablejsModule } from '@moddi3/ngx-sortablejs';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

import { EnvModule } from '@common/modules/env';
import { UtilsModule } from '@common/utils/utils.module';
import { GtmModule } from '@common/modules/gtm';

import jss from 'jss';

import { CDN_URL, PREFER_RESIZED_PREVIEW } from '@components/sp-file-manager';

import { EEnvTypes } from '@common/enums/env-types.enum';

import { translationProviderConfig, translationsModuleConfig } from '@common/configs/translations.config';
import { sortableJsRootConfig } from '@common/configs/sortablejs.config';
import { createStableJssOptions } from '@common/configs/jss.config';

import { JwtInterceptor } from '@web/core/interceptors/jwt.interceptor';

import { AppComponent } from './app.component';
import { AppStoreModule } from './store/app-store.module';
import { LayoutModule } from './layout/layout.module';
import { AppRoutingModule } from './app-routing.module';

import { environment } from '@web-env/environment';
import { SENTRY_ERROR_HANDLER_PROVIDER } from '@common/configs/sentry.browser.config';
import { provideIntegrations } from '@integrations/shared/provide-integrations';

jss.setup(createStableJssOptions());

const isProd = environment.type === EEnvTypes.PROD;

let fmUrl = environment.fileManagerUrl;
let onlyMemberModules = [GtmModule.forRoot('landing-pages', environment)];

if (window.location.pathname.includes('websites/builder/admin')) {
    onlyMemberModules = [];
    fmUrl += '/admin';
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppStoreModule,
        LayoutModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        BsDropdownModule.forRoot(),
        PopoverModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        ModalModule.forRoot(),
        FileManagerModule.forRoot({ url: fmUrl }),
        EnvModule.forRoot(environment),
        UtilsModule,
        SortablejsModule.forRoot(sortableJsRootConfig),
        ...onlyMemberModules,
    ],
    providers: [
        translationProviderConfig,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true,
        },
        {
            // Disable popover api for cdk overlay, because it causes issues with ngx-bootstrap popovers/dropdowns
            provide: OVERLAY_DEFAULT_CONFIG,
            useValue: {
                usePopover: false,
            },
        },
        {
            provide: CDN_URL,
            useValue: environment.fileManagerCdnUrl,
        },
        {
            provide: PREFER_RESIZED_PREVIEW,
            useValue: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideTranslateService(translationsModuleConfig),
        SENTRY_ERROR_HANDLER_PROVIDER,
        provideIntegrations({ withQueryDevtools: !isProd, strict: !isProd }),
    ],
    bootstrap: [AppComponent],
    exports: [],
})
export class AppModule {}
